<template>
  <page>
    <div>
      <v-card>
        <form>
          <message :messages="messages"></message>
          <v-expansion-panels v-model="panel" multiple>
            <v-expansion-panel>
            <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Run Report
              </div>
            </v-expansion-panel-header>
              <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-sm>
                    <v-layout row wrap>
                      <v-flex lg6 sm6 xs12>
                        <v-autocomplete :items="runReports" v-model="form.runReport" :label="label.runReport" item-text="label" item-value="value" data-vv-name="form.runReport" :data-vv-as="label.runReport" :error-messages="errors.collect('form.runReport')"></v-autocomplete>
                      </v-flex>
                    </v-layout>
                     <v-layout row wrap>
                      <v-flex xs12 class="pt-3">
                        <v-btn color="primary" dark @click.prevent="doProceed()">
                            {{label.proceed}}<v-icon dark right >mdi-arrow-right-bold-box</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-card>
    </div>

  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'

export default {
  data() {
    return {
      label: {
        runReport: 'Run Report',
        proceed: 'Proceed'
      },
      form: {
        runReport: '1'
      },
      runReports: [
        { label: 'Cash list for Debtor Accounts', value: '1' },
        { label: 'Daily / Monthly Bank Balance', value: '2' },
        { label: 'Daily / Monthly Cash Book', value: '3' }
      ],
      toggleFilters: [true],
      panel: [0]
    }
  },
  methods: {
    doProceed() {
      switch (this.form.runReport) {
        case '1':
          this.$router.push({ name: 'cashListDebtor', params: { runRpt: this.form.runReport } })
          break
        case '2':
          this.$router.push({ name: 'bankBalance', params: { runRpt: this.form.runReport } })
          break
        default:
          this.$router.push({ name: 'cashBook', params: { runRpt: this.form.runReport } })
      }
    }
  },
  created() {
  },
  computed: {
  },
  watch: {
  },
  mixins: [
    MessageMixin
  ],
  components: {
  }
}

</script>
